import React from "react"
import styles from "./StripeAccountCard.module.css"
import stripeIcon from "assets/imagesV2/settings/stripe.svg"
import { Flex } from "antd"
import { spacings } from "themes/variables"
import { StripeActionButtons } from "./StripeActionButtons"
import { useDevice } from "hooks/useDevice"
import { StripeStatus } from "./StripeStatus"
import { StripeDetails } from "./StripeDetail"
import { StripeExpressMigrationBanner } from "./StripeExpressMigrationBanner"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import {
  isStripeChargesEnabledSelector,
  isStripeConnectedSelector,
  isStripeExpressAccountSelector,
  isStripePayoutsEmail,
  errorStripeMessage,
  stripeLinkSelector
} from "store/user"

export const StripeAccountCard = ({ className }) => {
  const { isMobile } = useDevice()
  const { t } = useTranslation()
  const stripeEmail = useSelector(isStripePayoutsEmail)
  const isStripeChargeEnabled = useSelector(isStripeChargesEnabledSelector)
  const stripeErrorMessage = useSelector(errorStripeMessage)
  const stripeAttachLink = useSelector(stripeLinkSelector)
  const isStripeConnected = useSelector(isStripeConnectedSelector)
  const isStripeExpressAccount = useSelector(isStripeExpressAccountSelector)
  return (
    <div className={className}>
      <div className={styles.wrapper}>
        <div className={styles.topRow}>
          <Flex gap={spacings.M} align="start" className={styles.detailsColumn}>
            <img src={stripeIcon} alt={"Stripe icon"} className={styles.stripeLogo} />
            <Flex vertical className={styles.detailsColumn}>
              <div className={styles.title}>Stripe</div>
              <div className={styles.account}></div>
              <div className={styles.accountDescription}>{t("pro.personal_info.stripe.card_description")}</div>
              {isMobile && <StripeStatus />}
            </Flex>
          </Flex>
          {!isMobile && (
            <Flex gap={spacings["3XL"]} align="center">
              <StripeStatus />
              <StripeActionButtons />
            </Flex>
          )}
        </div>
        <StripeDetails
          stripeEmail={stripeEmail}
          errorStripeMessage={stripeErrorMessage}
          isStripeChargeEnabled={isStripeChargeEnabled}
          stripeLink={stripeAttachLink}
        />
      </div>
      {isStripeConnected && !isStripeExpressAccount && <StripeExpressMigrationBanner />}
    </div>
  )
}

StripeAccountCard.propTypes = {
  className: PropTypes.string,
};